import { useAdminChapterStore } from '@/infrastructure/store/adminChapterStore';

export const useAdminChapters = () => {
  const store = useAdminChapterStore();
  return {
    chapters: store.chapters,
    isLoading: store.isLoading,
    error: store.error,
    fetchChapters: store.fetchChapters,
    createChapter: store.createChapter,
    updateChapter: store.updateChapter,
    deleteChapter: store.deleteChapter,
    clearError: store.clearError,
  };
};
